import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Clark extends Lit3formBlock {
  static get characterName() {
    return 'clark';
  }

  static get characterProperties() {
    return {
      header: { type: String },
      description: { type: String },
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid clark-layout">
          ${this.headerHTML}
          <div class="images">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    return html`
      <div class="image-wrapper">
        ${this.imageInternalHtml(image)}
      </div>
    `;
  }

  imageInternalHtml(image) {
    return !!image.text
      ? html`
          <a class="image" href=${this.imageHref(image)} rel="noopener">
            <img src=${this.imageUrl(image)} />
          </a>
          <h3 class="image-title bold">
            ${unsafeHTML(this.withLineBreaks(image.title))}
          </h3>
          <p class="image-description font-size-small">
            ${unsafeHTML(this.withLineBreaks(image.description))}
          </p>
          ${this.textSectionsHTML(image)}
          <cta-text
            cta-data=${this.imageCtaData(image)}
            .ctaAnalyticsData=${analyticsCtaDataObject(image, this.headerText)}
          ></cta-text>
        `
      : html`
          <div class="image">
            <img src=${this.imageUrl(image)} />
          </div>
        `;
  }

  textSectionsHTML(image) {
    return image.text_sections?.length > 0
      ? html`
          <div class="text-sections-wrapper">
            ${image.text_sections.map(section => {
              return html`
                <span class="text-section">
                  <p>
                    <b>${unsafeHTML(this.withLineBreaks(section.heading))}</b>
                    ${section.paragraphs.map(paragraph => {
                      return unsafeHTML(this.withLineBreaks(paragraph));
                    })}
                  </p>
                </span>
              `;
            })}
          </div>
        `
      : html``;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 300);
  }

  imageCtaData(image) {
    let cta = {};
    if (image) {
      cta.text = image.text;
      cta.notBold = true;
      cta.url = image.url;
    }
    return JSON.stringify(cta);
  }

  get imagesArr() {
    return !this.content.images || this.content.images.length === 0
      ? []
      : this.content.images;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <div class="header details-row">
            <h2>${unsafeHTML(this.headerText)}</h2>
            ${this.descriptionHTML}
          </div>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description details-row">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }

  get headerText() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionText() {
    return this.withLineBreaks(this.content.description) || '';
  }
}
Clark.defineElement();
